import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl, getDateWithDay } from "../../comman/config.js";
import { MainRequirementFilter } from "../../components/Filter/MainRequirementFilter.js";
import toast, { Toaster } from "react-hot-toast";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/solid";
import Select from 'react-select';
import Loader from '../../components/Loader'
import { menuAboveTable } from "../../comman/selectMenu";

// import Pagination from "react-js-pagination";

function IssueListOld() {
  const today = new Date().toISOString().split("T")[0];
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [session, setSession] = useState({});
  const [issueStatus, setIssueStatus] = useState({});
  const [item, setItem] = useState({});
  const [kit,setKit] = useState({})
  const [kitList,setKitList] = useState([])
  const [itemIngredientList, setItemIngredientList] = useState([]);
  const [ingredientList, setIngredientList] = useState([]);
  const [loading, setLoading] = useState(false)

  const [activeIndex, setActiveIndex] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  
  useEffect(()=>{
    getIngredientList()
  },[itemIngredientList])

  useEffect(() => {
   
    if(fromDate && toDate){
      getKitList();
    }
  }, [fromDate, toDate, session, item, issueStatus])

  useEffect(()=>{
    if(activeIndex !== null){
      getKitItemsList()
    }
  },[kit,item,activeIndex])

  const handelFilterChange = async (from_date, to_date, session, item, issueStatus) => {
        setActiveIndex(null)
        setFromDate(from_date);
        setToDate(to_date);
        setSession(session);
        setItem(item);
        setIssueStatus(issueStatus)
  };

  const getIngredientList = async () => {
    const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`);
    const existingIngredientIds = itemIngredientList?.map(item => item.ingredient_id) || [];
    const list = response.data.data.filter((item) => item.status == 1 && item?.store?.id == 1 && !existingIngredientIds.includes(item.id));
    // console.log(list)
    setIngredientList(list);
  };

  

  const getKitItemsList = async ()=>{
    setLoading(true);
    const kit = kitList.find((item, index) => index == activeIndex);
    // console.log(kit)
    const condition = `pr.menu_item_id='${kit.menu_item_id}' AND pr.date = '${kit.date}' AND pr.session='${kit.session}' AND pr.batch = '${kit.batch}' AND im.store = 1`;
    const RecipeDbData = await axios.get(`${baseUrl}/return_receipt/ingredient_list?condition=${condition}`);
    const ingredientsList = RecipeDbData.data.data;
   
    if(ingredientsList.length > 0){
      const updatedIngredientsList = [];
      for (const i of ingredientsList) {
      
        if (parseFloat(i.return_qty) != 0) {
          const condition = `date = '${kit.date}' AND session = '${kit.session}' AND menu_item_id = '${kit.menu_item_id}' AND batch = '${kit.batch}' AND ingredient_id = '${i.ingredient_id}'`;
          // console.log(condition);
          const response = await axios.get( `${baseUrl}/comman/list?table=item_requirement_detail&condition=${condition}`);
          
          let return_receipt_qty;
          let return_receipt_status;
          if(response.data.data.length > 0){
            return_receipt_qty = response.data.data[0].return_receipt_qty;
            return_receipt_status = response.data.data[0].return_receipt_status;
            // console.log(response.data.data);
          }

          console.log(return_receipt_status);
          updatedIngredientsList.push({
            ...i,
            return_qty : i.return_qty ?? 0,
            return_receipt_qty: return_receipt_qty ?? 0,
            return_receipt_status : return_receipt_status
          });
        }
        };
      // setSelectedItem(item);
      // console.log(updatedIngredientsList)
      setLoading(false);
      setItemIngredientList(updatedIngredientsList);
    }
  }

  const getKitList = async () => {
    setLoading(true);
    // let condition = `requirement_status = 2 AND ingredient_added = 2`;
    let condition = `1`;
    if(fromDate == toDate){
        condition += ` AND date = '${fromDate}' `;
    }else if(fromDate && toDate){
        
      condition += ` AND (date >= '${fromDate}' AND date  <= '${toDate}') `;
    }
    if(session?.value && session?.value != "all"){
      condition += ` AND session = '${session?.value}'`;
    }
    if(item?.value && item?.value != "all"){
      condition += ` AND menu_item_id = '${item?.value}'`;
    }
    // if(issueStatus?.value && issueStatus != 'undefined'){
    //   condition += ` AND return_receipt_status = '${issueStatus?.value}'`
    // }

    if(issueStatus.length > 0 && issueStatus != "undefined"){

      const hasAll = issueStatus.some((status) => status?.value == 0);

      if(!hasAll){
        condition += `AND (`;
  
        issueStatus.map((status, index) => {
          condition += ` return_receipt_status = '${status?.value}' `;
          if((index + 1)  != issueStatus.length){
            condition += `OR `;
          }
        })
  
        condition += ` )`
      }
    }
    
        const response = await axios.get(`${baseUrl}/comman/list?table=item_requirement_master&condition=${condition}`)
        const kitList = response.data.data;
        //setKitList(kitList)

    // Process each kit to check if it has ingredients with non-zero return quantities
    const filteredKitList = [];

    for (const kit of kitList) {
      const condition = `pr.menu_item_id='${kit.menu_item_id}' AND pr.date = '${kit.date}' AND pr.session='${kit.session}' AND pr.batch = '${kit.batch}' AND im.store = 1`;
      const recipeResponse = await axios.get(`${baseUrl}/return_receipt/ingredient_list?condition=${condition}`);

      // Only add kits that have data (the backend has already filtered out kits with all-zero return_qty)
      if (recipeResponse.data.data && recipeResponse.data.data.length > 0) {
        filteredKitList.push(kit);
      }
    }
    setKitList(filteredKitList);
    setLoading(false);
}
  

  const clearItem = () => {
    setActiveIndex(null)
    setItemIngredientList(null);
    getKitList()
  };

  const handleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
    setKit(kitList.find((item, i) => i == index))
  };
  

  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;
    
    setItemIngredientList((prevFormData) => {
      const updatedFormData = [...prevFormData];
      
        updatedFormData[index] = { ...updatedFormData[index], [name]: value };
    
      return updatedFormData;
    });
  };

  const handleAddButtonClick = (index) => {
    setItemIngredientList((prevFormData) => {
      const updatedFormData = [...prevFormData];
      updatedFormData[index] = {...updatedFormData[index], add_return_receipt: true};
      return updatedFormData;
    });
  }

  const handleSave = async() => {

    if(selectedRows.length == 0){
      alert("Please select at least one row");
      setSelectedRows([]);
      return;
    }

    if(selectedRows.some(item => item.return_receipt_qty == 0 && item.return_receipt_status == 1)){
      alert("One or more items have an empty issue qty value.");
      setSelectedRows([]);
      return;
    }
    if(selectedRows.filter(item => item?.return_receipt_qty > 0).some(item => item.ingredient_id === null)){
      alert("One or more items have an empty ingredient value.");
      setSelectedRows([]);
      return
    }
    console.log(selectedRows);
    if(itemIngredientList.some(item => item.ingredient_id === null)){
      alert("One or more items have an empty ingredient value.");
      return
    }
    try{
        
        // console.log(itemIngredientList,kit)
      const response = await axios.post(`${baseUrl}/return_receipt/ingredient_update`,
        { ingredientsList : itemIngredientList,
          selectedRows : selectedRows,
          item: kit});
          toast.success("Item added successfully!");
          clearItem()
    }catch (error) {
      toast.error("Failed to add item. Please try again.");
    }
    setSelectedRows([]);
  }
  console.log("selected rows:",selectedRows);

  const handleSwitchSelectAll = () => {
    if (selectAll) {
        setSelectedRows([]);
    } else {
        setSelectedRows(itemIngredientList.filter((item) => item.return_receipt_status == 1 || item.return_receipt_status == 2 || item.return_receipt_status == 3 || item.return_receipt_status == undefined )); // Select all rows
    }
    setSelectAll(!selectAll);
  };

  const handleToggleSelect = (index) => {
    const updatedSelectedRows = selectedRows.includes(itemIngredientList[index])
        ? selectedRows.filter(item => item !== itemIngredientList[index]) // Deselect
        : [...selectedRows, itemIngredientList[index]]; // Select

        setSelectedRows(updatedSelectedRows);
};

  const handleSaveButton = async() => {
    try{
        
        // console.log(itemIngredientList,kit)
      const response = await axios.post(`${baseUrl}/return_receipt/ingredient_save`,
        { ingredientsList : itemIngredientList,
          item: kit});
          toast.success("Item saved successfully!");
          clearItem()
    }catch (error) {
      toast.error("Failed to add item. Please try again.");
    }
    
  }  


  const handleAddNewIngredientRow = ()=> {
    setItemIngredientList([...itemIngredientList,{
      ingredient:'', 
      ingredient_obj:{},
      ingredient_id:null, 
      unit:null, 
      unitname:'', 
      wastage:0,
      gross_issued_qty:0,
      return_qty:0.01, 
      // net_issued_qty:0, 
      gross_required_qty:0.01, 
      required_qty:0, 
      issue_status:1,
      isNew: true 
    }])
  }

  const handleNewIngredientChange = (selectedOptions,index) => {
    // setNewIngredient((prev)=>({...prev,ingredient:ingredient}))
    // console.log(selectedOptions)
    const updatedList =   [...itemIngredientList]
    updatedList[index].ingredient_obj = selectedOptions
    updatedList[index].ingredient = selectedOptions.ingredient
    updatedList[index].ingredient_id = selectedOptions.value
    updatedList[index].unit = selectedOptions.unit
    updatedList[index].unitname = selectedOptions.unitname
    // console.log(updatedList[index])
    setItemIngredientList(updatedList)
  }

  return (
    <div className="p-4">
      {loading && <Loader />}
      <div className="flex justify-between items-center py-4 px-6">
        <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">
          Store Return Receipt (Old)
        </h1>

        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div className="relative shadow-md sm:rounded-lg">
        <MainRequirementFilter handleFilterChange={handelFilterChange} page="receipt" />
      </div>

      <div>
        {kitList.map((item, index) => (
          <div key={index} className="border-b mt-4">
            <div
              className={`flex justify-between items-center p-4 cursor-pointer accordion-title border rounded 
              ${item.return_receipt_status == 1 ? 'bg-orange-400' :
                  (item.return_receipt_status == 2 ? 'bg-yellow-400' : 'bg-green-400')}`}
              onClick={() => handleClick(index)}>
              <span className="text-sm sm:text-base break-words">{`${item.kit_no} (${item.return_receipt_status === 1 ? 'Pending Received' : (item.return_receipt_status == 2 ? "Partly Received" : "Received")})`}</span>
              {index === activeIndex ? (
                <ChevronUpIcon className="w-6 h-6 flex-shrink-0" />
              ) : (
                <ChevronDownIcon className="w-6 h-6 flex-shrink-0" />
              )}
            </div>
            {index === activeIndex && (
              <div className="space-y-2 p-4">
                <div>
                  {/* Desktop Table View */}
                  <div className="hidden lg:block">
                    <table className="w-full mt-10 text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                      <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                          <th scope="col" className="px-2 py-1 border border-black text-center">
                            <input type="checkbox" className="newrow checkboxAll" onChange={handleSwitchSelectAll} checked={selectAll} />
                          </th>
                          <th scope="col" className="px-2 py-1 border border-black text-center w-60">Ingredient</th>
                          <th scope="col" className="px-2 py-1 border border-black text-center">Returned Qty</th>
                          <th scope="col" className="px-2 py-1 border border-black text-center">Received Qty</th>
                          <th scope="col" className="px-2 py-1 border border-black text-center">Receipt Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {itemIngredientList?.map((item, index) => (
                          <tr key={index} className="border border-black-b">
                            {(((item.return_receipt_status !== 3) || (item.return_receipt_status === 3 && item.add_return_receipt)) && ((item.return_receipt_status !== 2) || (item.return_receipt_status === 2 && item.add_return_receipt))) ? (
                              <td className="px-2 py-1 border border-black text-center">
                                <input
                                  type="checkbox"
                                  checked={selectedRows.includes(item)}
                                  onChange={() => handleToggleSelect(index)}
                                />
                              </td>
                            ) : (
                              <td className="px-2 py-1 border border-black text-center"></td>
                            )}
                            {item.isNew ? (
                              <td className="px-2 py-1 border border-black text-center">
                                <Select
                                  {...menuAboveTable}
                                  classNamePrefix="select"
                                  className='basic-multi-select'
                                  value={item.ingredient_obj}
                                  name="ingredient"
                                  onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                                  options={ingredientList.map((item) => ({
                                    value: item.id,
                                    label: `${item.ingredient} (${item.eng_name})`,
                                    unit: item.unit?.id,
                                    unitname: item.unit?.name,
                                    ingredient: `${item.ingredient}`,
                                    eng_name: item.eng_name,
                                  }))}
                                  placeholder="Ingredient List"
                                  filterOption={(option, inputValue) => {
                                    return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                                  }}
                                />
                              </td>
                            ) : (
                              <td className="px-2 py-1 border border-black text-center">{item.ingredient}</td>
                            )}
                            <td className="px-2 py-1 border border-black text-center">{item?.return_qty ?? 0}</td>
                            <td className="px-2 py-1 border border-black text-center">
                              <input type="number"
                                id="return_receipt_qty"
                                name="return_receipt_qty"
                                value={item?.return_receipt_qty}
                                onWheel={(e) => e.target.blur()}
                                onChange={handleInputChange(index)}
                                onKeyDown={(e) => {
                                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                    e.preventDefault();
                                  }
                                }}
                                className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                              />
                              {(item.return_receipt_status === 3 || item.return_receipt_status === 2) && (
                                <>
                                  <button
                                    onClick={() => handleAddButtonClick(index)}
                                    className='px-1 rounded border mx-2 scale-150 hover:bg-gray-300'
                                  >
                                    &#x2b;
                                  </button>
                                  {item.add_return_receipt && (
                                    <input
                                      type="number"
                                      id="add_return_receipt_qty"
                                      name="add_return_receipt_qty"
                                      value={item?.add_return_receipt_qty ?? ''}
                                      onWheel={(e) => e.target.blur()}
                                      onChange={handleInputChange(index)}
                                      onKeyDown={(e) => {
                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                          e.preventDefault();
                                        }
                                      }}
                                      className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                                    />
                                  )}
                                </>
                              )}
                            </td>
                            <td className="px-2 py-1 border border-black text-center">{item.return_receipt_status == 3 ? "Received" : (item.return_receipt_status == 2 ? "Partly Received" : "Pending")}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile Card View */}
                  <div className="block lg:hidden">
                    <div className="mb-4">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-sm font-medium">Select All</span>
                        <input type="checkbox" className="newrow checkboxAll" onChange={handleSwitchSelectAll} checked={selectAll} />
                      </div>
                    </div>

                    {itemIngredientList?.map((item, index) => (
                      <div key={index} className="border rounded-lg p-3 mb-3 bg-white shadow-sm">
                        <div className="flex items-center justify-between mb-3">
                          <div className="flex-1">
                            {item.isNew ? (
                              <Select
                                {...menuAboveTable}
                                classNamePrefix="select"
                                className='basic-multi-select'
                                value={item.ingredient_obj}
                                name="ingredient"
                                onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                                options={ingredientList.map((item) => ({
                                  value: item.id,
                                  label: `${item.ingredient} (${item.eng_name})`,
                                  unit: item.unit?.id,
                                  unitname: item.unit?.name,
                                  ingredient: `${item.ingredient}`,
                                  eng_name: item.eng_name,
                                }))}
                                placeholder="Ingredient List"
                                filterOption={(option, inputValue) => {
                                  return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                                }}
                              />
                            ) : (
                              <div className="font-medium text-sm">{item.ingredient}</div>
                            )}
                            <div className="text-xs text-gray-500 mt-1">
                              Status: {item.return_receipt_status == 3 ? "Received" : (item.return_receipt_status == 2 ? "Partly Received" : "Pending")}
                            </div>
                          </div>
                          {(((item.return_receipt_status !== 3) || (item.return_receipt_status === 3 && item.add_return_receipt)) && ((item.return_receipt_status !== 2) || (item.return_receipt_status === 2 && item.add_return_receipt))) && (
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(item)}
                              onChange={() => handleToggleSelect(index)}
                              className="ml-2"
                            />
                          )}
                        </div>

                        <div className="grid grid-cols-1 gap-2 text-sm mb-3">
                          <div className="flex justify-between">
                            <span className="text-gray-500">Returned Qty:</span>
                            <span className="font-medium">{item?.return_qty ?? 0}</span>
                          </div>
                        </div>

                        <div className="mt-3">
                          <div className="text-xs text-gray-500 mb-1">Received Qty</div>
                          <div className="flex items-center gap-2">
                            <input type="number"
                              id="return_receipt_qty"
                              name="return_receipt_qty"
                              value={item?.return_receipt_qty}
                              onWheel={(e) => e.target.blur()}
                              onChange={handleInputChange(index)}
                              onKeyDown={(e) => {
                                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                  e.preventDefault();
                                }
                              }}
                              className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                            />
                            {(item.return_receipt_status === 3 || item.return_receipt_status === 2) && (
                              <>
                                <button
                                  onClick={() => handleAddButtonClick(index)}
                                  className='px-2 py-1 rounded border hover:bg-gray-300 text-sm'
                                >
                                  +
                                </button>
                                {item.add_return_receipt && (
                                  <input
                                    type="number"
                                    id="add_return_receipt_qty"
                                    name="add_return_receipt_qty"
                                    value={item?.add_return_receipt_qty ?? ''}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange(index)}
                                    onKeyDown={(e) => {
                                      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                        e.preventDefault();
                                      }
                                    }}
                                    className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                                  />
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* <div className="flex flex-col sm:flex-row gap-2 items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                  {kit.issue_status !== 3 && (
                    <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                      {((kit.return_receipt_status !== 3) && (kit.return_receipt_status !== 2)) && (
                        <button
                          className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                          type="button"
                          onClick={() => handleSaveButton()}
                        >
                          Save
                        </button>
                      )}
                      <button
                        className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                        type="button"
                        disabled={kit.issue_status == 3}
                        onClick={() => handleSave()}
                      >
                        Submit for Return
                      </button>
                      <button
                        className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                        type="button"
                        disabled={kit.issue_status === 3}
                        onClick={() => { handleAddNewIngredientRow() }}
                      >
                        Add Ingredient
                      </button>
                    </div>
                  )}
                </div> */}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default IssueListOld;
